/**
 * 预生产环境
 */
// 已开大屏类型路由目录
const NJSCREENCONTENTS = ['nj']

// 已开大屏所有市区县
const NJSCREENSITE = [
    {
        key: 'fengcheng',
        label: '丰城市',
        locId: 1565,
        isArea: true,
        center: [28.106554710320925, 115.817240843028728]
    },
    {
        key: 'wudalianchi',
        label: '五大连池市',
        locId: 1073,
        isArea: false,
        center: [48.73434746467879108, 126.63450021565670056]
    },
    {
        key: 'zhangjiajie',
        label: '张家界',
        locId: 205,
        isArea: false,
        center: [27.585702227136, 112.26046418076]
    },
    {
        key: 'ganxianqu',
        label: '赣县区',
        locId: 1528,
        isArea: false,
        center: [25.895865, 115.066147]
    }
]

const currRouteName = window.location.pathname.split('/')[2]

// 获取当前市 | 区 | 县信息
const currSite =
    NJSCREENSITE.findIndex((item) => item.key === currRouteName) !== -1
        ? NJSCREENSITE.find((item) => item.key === currRouteName)
        : { key: 'fengcheng' }

const CEMUYI_TIANDITU_KEY = 'eb7fb18b99667b930192f6ac709bb524'
const SOCKET_URL = `tc-gateway-ws.tuliu.com/nongshi/websocket/screenMachine${currSite.key
    .slice(0, 1)
    .toUpperCase() + currSite.key.slice(1)}`
const SOCKET_URL2 =
    'equity-p-right.nanningnongjiao.com/websocket/farmMachine/auctionPrice'
const javaBase = 'https://equity-p-right.nanningnongjiao.com'
const javaBase2 = 'https://www.nanningnongjiao.com'
const javaBase3 = 'https://equity-p-right.nanningnongjiao.com/api'
const javaBase4 = 'https://tc-gateway.tuliu.com'
const javaBase5 = 'https://tc-gateway.tuliu.com/nongshi'
const SOCKET_TYPE = 'stage'

// 魏都区地图 json 特殊处理，注：魏都区站点 id 更换，这里得同步更换
const WDQLOCID = '1982'

// 安化县站点
const AHLOCID = '2215'

// 湖南省站点
const HNLOCID = '407'

// 祁阳市站点
const QYLOCID = '2230'

// 海南省站点
const HNSLOCID = '459'

// 湘潭市站点
const XTLOCID = '410'

// 十八洞站点
const SBDLOCIT = '3506'

// 海南省及所有子级区域的定制大屏站点 id
const HAINLOCID = [
    '195',
    '459',
    '460',
    '461',
    '2489',
    '2490',
    '2492',
    '2493',
    '2494',
    '2495',
    '2496',
    '2497',
    '2498',
    '2499',
    '2500',
    '2501',
    '2502',
    '2503',
    '2504',
    '2505',
    '2506',
    '2507',
    '2508',
    '2509',
    '3367',
    '3383',
    '3384',
    '3385',
    '3386',
    '3476'
]

export default {
    javaBase,
    javaBase2,
    javaBase3,
    javaBase4,
    javaBase5,
    CEMUYI_TIANDITU_KEY,
    SOCKET_URL,
    SOCKET_URL2,
    SOCKET_TYPE,
    WDQLOCID,
    AHLOCID,
    HNLOCID,
    HNSLOCID,
    XTLOCID,
    SBDLOCIT,
    HAINLOCID,
    QYLOCID,
    NJSCREENCONTENTS,
    NJSCREENSITE
}
